module.exports = __webpack_public_path__ + "img/icon-minus.d71acfdf.svg";